module.exports = __webpack_public_path__ + "static/media/F2.c46369d2.jpg";